var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStartCall = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 14,
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.6224 13.0166C12.0462 13.0166 10.4891 12.6964 8.95083 12.0563C7.41254 11.416 6.01293 10.5086 4.75208 9.33392C3.49123 8.15926 2.51718 6.85533 1.82995 5.4222C1.14281 3.9891 0.799199 2.53837 0.799199 1.07C0.799199 0.858568 0.874847 0.682361 1.02614 0.541401C1.17744 0.40044 1.3666 0.329956 1.59354 0.329956H4.6575C4.83404 0.329956 4.99164 0.385757 5.13031 0.497351C5.26899 0.608945 5.35095 0.741094 5.37619 0.893806L5.86795 3.36064C5.89319 3.54859 5.88688 3.70718 5.84901 3.83639C5.81123 3.9656 5.74189 4.0772 5.641 4.17118L3.80644 5.89798C4.05863 6.3326 4.35806 6.75251 4.70474 7.15781C5.05151 7.56311 5.4329 7.95363 5.84901 8.32953C6.23987 8.69375 6.64967 9.03143 7.07839 9.34274C7.50712 9.65404 7.96101 9.93888 8.44014 10.1973L10.218 8.54104C10.3315 8.43528 10.4797 8.35599 10.6625 8.30315C10.8453 8.25023 11.025 8.23562 11.2015 8.25905L13.8115 8.75247C13.988 8.79942 14.133 8.8846 14.2465 9.00791C14.36 9.13131 14.4167 9.26932 14.4167 9.42203V12.2765C14.4167 12.4879 14.3411 12.6642 14.1898 12.8051C14.0385 12.9461 13.8493 13.0166 13.6224 13.0166Z",
  fill: "#F78222"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStartCall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/startCall.a813dad7902d50daca81953bdebf1ffa.svg";